
import { logger } from '@/services/LoggingService';
import { VezgoStorageKeys } from '../../utils/storage-keys';

interface MigrationResult {
  success: boolean;
  migratedKeys: string[];
  errors: string[];
}

export function migrateLegacyData(): MigrationResult {
  const result: MigrationResult = {
    success: true,
    migratedKeys: [],
    errors: []
  };

  try {
    // Only migrate navigation-related session storage (not database data)
    const keys = [VezgoStorageKeys.STATE, VezgoStorageKeys.RETURN_URL, VezgoStorageKeys.PROVIDER];
    
    for (const key of keys) {
      const value = sessionStorage.getItem(key);
      if (value) {
        localStorage.setItem(key, value);
        sessionStorage.removeItem(key);
        result.migratedKeys.push(key);
        
        logger.debug('migration', `Migrated ${key} from sessionStorage to localStorage`);
      }
    }
    
    return result;
  } catch (error) {
    logger.error('migration', 'Error during storage migration', {
      error: error instanceof Error ? error.message : String(error)
    });
    
    result.success = false;
    result.errors.push(error instanceof Error ? error.message : String(error));
    return result;
  }
}
